import { useNavigate, useLocation } from "react-router-dom";
import { useContext, useState } from "react";
import { AuthContext } from "../../auth/AuthContext";
import { usePortalData } from "../context/PortalDataContext";
import LegalModal from "../../pages/LegalModal";

const NAV_SECTIONS = [
  {
    section: "Main",
    items: [
      { label: "Dashboard",            icon: "pi-home",      path: "/"              },
      { label: "My Prescriptions",     icon: "pi-file-edit", path: "/prescriptions" },
      { label: "Refill Requests",      icon: "pi-refresh",   path: "/refills",      badge: true },
      { label: "Upload Prescription",  icon: "pi-upload",    path: "/upload"        },
      { label: "My Invoices",          icon: "pi-receipt",   path: "/invoices"      },
      { label: "Health History",       icon: "pi-heart",     path: "/health-history" },
    ],
  },
  {
    section: "Clinic",
    items: [
      { label: "Find a Doctor",        icon: "pi-search",     path: "/find-doctor"         },
      { label: "My Appointments",      icon: "pi-calendar",   path: "/appointments"         },
    ],
  },
  {
    section: "Account",
    items: [
      { label: "Notifications",    icon: "pi-bell",  path: "/notifications", badge: "notif" },
      { label: "Friends & Family", icon: "pi-users", path: "/relatives" },
      { label: "My Profile",       icon: "pi-user",  path: "/profile"   },
    ],
  },
];

export default function PortalSidebar({ inDrawer = false, onNavigate }) {
  const navigate  = useNavigate();
  const location  = useLocation();
  const { logout } = useContext(AuthContext);
  const { pendingRefillCount, selectedPharmacyName, unreadNotifCount } = usePortalData();
  const [legalModal, setLegalModal] = useState(null); // "terms" | "privacy" | null

  const handleClick = (path) => {
    navigate(path);
    onNavigate?.();
  };

  const handleLogout = () => {
    logout();
    navigate("/login");
    onNavigate?.();
  };

  return (
    <div
      className={inDrawer ? undefined : "portal-sidebar"}
      style={inDrawer ? { display: "flex", flexDirection: "column", height: "100%" } : undefined}
    >
      {/* Nav sections */}
      <div style={{ flex: 1 }}>
        {NAV_SECTIONS.map((section) => (
          <div key={section.section}>
            <div className="sidebar-section-label">{section.section}</div>

            {section.items.map((item) => {
              const isActive =
                location.pathname === item.path ||
                (item.path !== "/" && location.pathname.startsWith(item.path));

              const badgeCount = item.badge === true
                ? pendingRefillCount
                : item.badge === "notif"
                  ? (unreadNotifCount ?? 0)
                  : 0;

              return (
                <button
                  key={item.path}
                  className={`sidebar-nav-item ${isActive ? "active" : ""}`}
                  onClick={() => handleClick(item.path)}
                >
                  <i className={`pi ${item.icon}`} />
                  <span>{item.label}</span>
                  {badgeCount > 0 && (
                    <span className="sidebar-nav-badge">{badgeCount}</span>
                  )}
                </button>
              );
            })}

            <div className="sidebar-divider" />
          </div>
        ))}
      </div>

      {/* ── Bottom section ─────────────────────────────────────────── */}
      <div style={{ padding: "12px 16px", borderTop: "1px solid var(--border-light)" }}>
        {/* Legal links */}
        <div style={{
          textAlign: "center", fontSize: 10.5, color: "var(--text-muted)",
        }}>
          <span onClick={() => setLegalModal("privacy")} style={{ cursor: "pointer", textDecoration: "underline" }}>
            Privacy Policy
          </span>
          {" · "}
          <span onClick={() => setLegalModal("terms")} style={{ cursor: "pointer", textDecoration: "underline" }}>
            Terms of Service
          </span>
        </div>

        {/* Version / brand */}
        <div style={{
          marginTop: 10, textAlign: "center",
          fontSize: 10.5, color: "var(--text-muted)", lineHeight: 1.6,
        }}>
          FitMe
          <br />
          <span style={{ opacity: 0.7 }}>
            © {new Date().getFullYear()} Coffer Smart
          </span>
        </div>
      </div>

      <LegalModal type={legalModal} onClose={() => setLegalModal(null)} />
    </div>
  );
}